export function quoteAnimate() {
    if (typeof gsap === "undefined" || typeof ScrollTrigger === "undefined") return;

    const quote = document.querySelector(".introduction__quote");
    if (!quote) return;

    gsap.registerPlugin(ScrollTrigger);

    gsap.from(quote, {
        y: 30,
        opacity: 0,
        duration: 0.6,
        ease: "power2.out",
        scrollTrigger: {
            trigger: quote,
            start: "top 85%",
            once: true
        }
    });
}
